/**
 * Copies passed text to the clipboard
 * @param {string} stext the selector you're looking for
 * @param text
 * @returns {Promise} a promise
 */
const copytoclipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    alert('Text copied to clipboard!');
  } catch (error) {
    console.error('Error copying text to clipboard:', error);
  }
};

export default copytoclipboard;
